import * as React from "react"
import styled from "styled-components"
import colors from "theme/colors"

const StyledSVG = styled.svg`
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 20px;
    height: 20px;
  }
`

const SvgComponent = ({
  color = colors.black,
  width = 24,
  height = 22,
}: React.SVGProps<SVGSVGElement>) => {
  const w = width
  const h = height
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 20.59 20.59"
      className="instagram-icon"
      aria-labelledby="mcd-instagram-title mcd-instagram-desc"
    >
      <title id="mcd-instagram-title">
        לינק שמעביר את המשתמש לאינסטאגראם של מקדונלדס
      </title>
      <desc id="mcd-instagram-desc">אייקון של אינסטאגראם של מקדונלדס</desc>
      <g data-name="Insta icon" transform="translate(.5 .5)">
        <path
          data-name="Path 289"
          d="M16.4 2H7.186A5.187 5.187 0 0 0 2 7.186V16.4a5.187 5.187 0 0 0 5.186 5.19H16.4a5.187 5.187 0 0 0 5.19-5.19V7.186A5.187 5.187 0 0 0 16.4 2zm4.033 14.4a4.035 4.035 0 0 1-4.033 4.038H7.186A4.035 4.035 0 0 1 3.152 16.4V7.186a4.035 4.035 0 0 1 4.034-4.034H16.4a4.035 4.035 0 0 1 4.033 4.033z"
          transform="translate(-2 -2)"
          stroke={color}
          fill="evenodd"
        />
        <path
          data-name="Path 290"
          d="M13.284 8.588a4.7 4.7 0 1 0 4.7 4.7 4.7 4.7 0 0 0-4.7-4.7zm0 8.348a3.653 3.653 0 1 1 3.653-3.653 3.653 3.653 0 0 1-3.653 3.653z"
          transform="translate(-3.489 -3.489)"
          stroke={color}
          fill="evenodd"
        />
        <circle
          data-name="Ellipse 5"
          cx="1"
          cy="1"
          r="1"
          transform="translate(14 3.795)"
        />
      </g>
    </StyledSVG>
  )
}

export default SvgComponent
